import { Portal } from 'components/Shared/Portal';
import { usePopup } from 'hooks/usePopup';

export const PopupPortal = () => {
  const modals = usePopup();

  return modals?.length ? (
    <Portal>
      <div>{modals.map(modal => modal.modal)}</div>
    </Portal>
  ) : null;
};
